// extracted by mini-css-extract-plugin
export default {"container":"Review_container__2o9FP","card":"Review_card__dOH-a","image":"Review_image__eNHaP","heading":"Review_heading__vyvFf"};